import { useContext, useEffect, useState } from "react";
import { userAuthContext } from "../../ContextAPI/isAuth";
import { citiesContext } from "../../ContextAPI/Cities";
import { updateUser } from "../../actions/index";
import { useNavigate } from "react-router-dom";
import InputBox from "../Login/InputBox";
import SelectBox from "../Login/SelectBox";
import RadioButton from "../Login/RadioButton";
import { motion } from "framer-motion";
import "./styles.css";
const bloodType = ["a", "a+", "b", "b+"];

const Profile = () => {
  const [isAuth, setIsAuth] = useContext(userAuthContext);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("tkn")));

  const initialState = {
    name: user.name,
    lastName: user.lastName,
    email: user.email,
    donator: user.donator,
    bloodType: user.bloodType,
    address: user.address
  };

  const cities = useContext(citiesContext);
  const [province, setProvince] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (!user) {
      setIsAuth(false);
    }
    for (let key in cities) {
      if (cities[key].includes(user.address)) {
        setProvince(key);

        break;
      }
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuth || !localStorage.getItem("tkn")) {
      return navigate("/auth");
    }
  }, [isAuth]);

  const handleEdit = (e) => {
    e.preventDefault();
    setIsEdit(true);
  };

  const updateInfo = async (e) => {
    e.preventDefault();
    try {
      const user = await updateUser(formData);
      if (user) setIsEdit(false);
      console.log(user);
    } catch (error) {
      console.log("My update user Error: ", error);
    }
  };

  const handleFormChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "donator") {
      value = value == "Donateur" ? true : false;
      //FOR CHECKED
      setUser({ ...user, donator: value });
    }
    setFormData((prev) => {
      return { ...prev, [e.target.name]: value };
    });
  };

  return (
    <motion.section
      initial={{ opacity: 0, transform: "translateY(10%)" }}
      animate={{ opacity: 1, transform: "translateY(0%)" }}
      exit={{ opacity: 0 }}
      className="profile"
    >
      <div className="container">
        <div className="profile__container">
          <h1 className="text-center">Votre Profile</h1>
          <div className="profile__information">
            <form
              onChange={isEdit ? handleFormChange : null}
              className="profile__form"
            >
              <div className="profile__form__fullName">
                <InputBox
                  label="Nom"
                  type="text"
                  name="name"
                  id="profile-name"
                  value={user.name}
                  active={true}
                  isDisabled={!isEdit}
                />
                <InputBox
                  label="Prenom"
                  type="text"
                  name="lastName"
                  id="profile-last-name"
                  value={user.lastName}
                  active={true}
                  isDisabled={!isEdit}
                />
              </div>
              <div className="profile__email__password">
                <InputBox
                  label="Email"
                  type="text"
                  name="email"
                  id="profile-email"
                  value={user.email}
                  active={true}
                  isDisabled={!isEdit}
                />
                <InputBox
                  label="Telephone"
                  type="tel"
                  name="tel"
                  id="auth-tel"
                  value={user.tel}
                  active={true}
                  isDisabled={!isEdit}
                />
              </div>
              <div className="profile__address">
                <SelectBox
                  name="province"
                  id="profile-province"
                  options={Object.keys(cities)}
                  label="Province"
                  selectedVal={province}
                  isDisabled={!isEdit}
                />
                <SelectBox
                  name="address"
                  id="profile-city"
                  options={cities[province]}
                  label="Ville"
                  selectedVal={user.address}
                  isDisabled={!isEdit}
                />
              </div>
              <div className="profile__blood__info">
                <SelectBox
                  name="bloodType"
                  id="auth-bloodType"
                  options={bloodType}
                  label="Votre Groupe Sanguin"
                  selectedVal={user.bloodType}
                  isDisabled={!isEdit}
                />
                <div className="profile__is_donator">
                  {user.donator ? (
                    <>
                      <RadioButton
                        name="donator"
                        value="Donateur"
                        selectedVal={user.donator}
                        isDisabled={!isEdit}
                        isSelected={true}
                      />
                      <RadioButton
                        name="donator"
                        value="Bénéficiaire"
                        selectedVal={user.donator}
                        isDisabled={!isEdit}
                      />
                    </>
                  ) : (
                    <>
                      <RadioButton
                        name="donator"
                        value="Donateur"
                        selectedVal={user.donator}
                        isDisabled={!isEdit}
                        isSelected={user.donator}
                      />
                      <RadioButton
                        name="donator"
                        value="Bénéficiaire"
                        selectedVal={user.donator}
                        isDisabled={!isEdit}
                        isSelected={true}
                      />
                    </>
                  )}
                </div>
              </div>
              <div className="profile__edit__button text-center">
                {isEdit ? (
                  <button className="btn btn-primary" onClick={updateInfo}>
                    Save
                  </button>
                ) : (
                  <button className="btn btn-primary" onClick={handleEdit}>
                    Edit
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </motion.section>
  );
};
export default Profile;
